import { CustomIconProps } from './art';

export const CheckmarkIcon = (props: CustomIconProps): JSX.Element => (
  <svg width="60" height="60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.649 45.001a2.5 2.5 0 01-1.825-.8l-12.15-12.925a2.503 2.503 0 013.65-3.425l10.3 10.975 21.025-23a2.5 2.5 0 113.7 3.35l-22.85 25a2.5 2.5 0 01-1.825.825h-.025z"
      fill="#00A624"
    />
  </svg>
);
